const SWITCH_SIZE = {
    small: { width: 24, height: 14, thumb: 10, translateX: 10 },
    medium: { width: 28, height: 16, thumb: 12, translateX: 12 },
    large: { width: 36, height: 20, thumb: 16, translateX: 16 },
};
const resolveSize = (size) => SWITCH_SIZE[size in SWITCH_SIZE ? size : "medium"];
export default function switchOverrides({ variables, }) {
    return {
        MuiSwitch: {
            styleOverrides: {
                root: ({ ownerState }) => {
                    const { width, height, thumb, translateX } = resolveSize(ownerState.size);
                    return {
                        width,
                        height,
                        padding: 0,
                        marginRight: variables.spacing_02,
                        "& .MuiSwitch-switchBase": {
                            padding: variables.spacing_01,
                            "&.Mui-checked": {
                                transform: `translateX(${translateX}px)`,
                                "& + .MuiSwitch-track": {
                                    backgroundColor: variables.interactive,
                                    opacity: 1,
                                },
                            },
                            "&.Mui-disabled + .MuiSwitch-track": {
                                opacity: 0.5,
                            },
                            "&.Mui-disabled:not(.Mui-checked) + .MuiSwitch-track": {
                                backgroundColor: variables.surface_track,
                            },
                        },
                        "& .MuiSwitch-thumb": {
                            width: thumb,
                            height: thumb,
                            backgroundColor: variables.surface_thumb,
                            boxShadow: "none",
                        },
                        "& .MuiSwitch-track": {
                            borderRadius: variables.border_radius_pill,
                            backgroundColor: variables.surface_track,
                            opacity: 1,
                        },
                    };
                },
            },
        },
    };
}
//# sourceMappingURL=switch.js.map